const getInitials = (str: string): string => {
  if (!str) {
    return '?'
  }

  const clean = str.replace(/\s+/g, '')
  if (!clean) {
    return '?'
  }

  const slice = clean.slice(0, 2).toLowerCase()
  return slice.charAt(0).toUpperCase() + slice.slice(1)
}

export default getInitials
